module.exports = __webpack_public_path__ + "static/media/ft.ab1708c3.jpg";